
  var _styles = {
  "button-container": {
    "marginTop": "0.26667rem",
    "marginBottom": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-evenly"
  },
  "change-button": {
    "borderRadius": "0.64rem",
    "height": "1.28rem",
    "width": "4.57333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)"
  },
  "change-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem"
  },
  "invite-button": {
    "borderRadius": "0.64rem",
    "height": "1.28rem",
    "width": "4.57333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "rgb(255,108,2)"
  },
  "invite-button__icon": {
    "width": "0.53333rem",
    "height": "0.53333rem",
    "marginRight": "0.21333rem"
  },
  "invite-button__text": {
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  }
};



  module.exports = _styles;
  